import { Component, OnInit, NgZone } from '@angular/core';
import { Platform } from 'ionic-angular';

import { NavController } from 'ionic-angular';
import { ecgDataService,ContactPage} from "../contact/contact"
declare var window: any;
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage implements OnInit {
    info: any;
    serviceList: Array<any> = new Array<any>();
    count: number = 0;
    constructor(
        public navCtrl: NavController,
        public platform: Platform,
        private ngZone: NgZone,
        private _ecgDataService: ecgDataService
    ) {
      
  }
    ngOnInit() {

        var that = this;
        if (!that.platform.is('cordova')) {
            this.platform.ready().then(() => {
                that.serviceList.push({                     
                        'domain': 'local.',
                        'type': '_http._tcp.',
                        'name': 'Becvert\'s iPad',
                        'port': 80,
                        'hostname': 'ipad-of-becvert.local',
                        'ipv4Addresses': ['192.168.1.125'],
                        'ipv6Addresses': ['2001:0:5ef5:79fb:10cb:1dbf:3f57:feb0'],
                        'txtRecord': {
                            'foo': 'bar'
                        }
                    
                });
                that.serviceList.push({
                    'domain': 'local.',
                    'type': '_http._tcp.',
                    'name': 'Becvert\'s iPad',
                    'port': 80,
                    'hostname': 'ipad-of-becvert.local',
                    'ipv4Addresses': ['192.168.1.125'],
                    'ipv6Addresses': ['2001:0:5ef5:79fb:10cb:1dbf:3f57:feb0'],
                    'txtRecord': {
                        'foo': 'bar'
                    }

                });
            });
        } else {
            this.platform.ready().then(() => {

                var zeroconf = window.cordova.plugins.zeroconf;
                console.log(zeroconf);
                this.info = "Testing";

                window.cordova.plugins.zeroconf.watch('_http._tcp.', 'local.',
                    function (result) {
                        that.ngZone.run(() => {
                            var action = result.action;
                            var service = result.service;
                            console.log(result);
                            that.info = result;
                            /* service : {
                                'domain' : 'local.',
                                'type' : '_http._tcp.',
                                'name': 'Becvert\'s iPad',
                                'port' : 80,
                                'hostname' : 'ipad-of-becvert.local',
                                'ipv4Addresses' : [ '192.168.1.125' ], 
                                'ipv6Addresses' : [ '2001:0:5ef5:79fb:10cb:1dbf:3f57:feb0' ],
                                'txtRecord' : {
                                    'foo' : 'bar'
                                }
                            } */
                            if (action == 'added') {
                                console.log('service added', service);
                                that.serviceList.push(service);
                                that.count++;
                            } else {
                                console.log('service removed', service);
                            }
                            // window.cordova.plugins.zeroconf.unwatch('_http._tcp.', 'local.', function (success) { console.log(success); }, function (error) { console.log(error); });
                        });
                    }
                    ,
                    function (res) {
                        console.log(res);
                    });
            });

        }
    }
    saveService(service) {
        this._ecgDataService.dataServerIp = service.ipv4Addresses[0];
        this._ecgDataService.dataServerPort = service.port;
        this.navCtrl.push(ContactPage);
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts